import {MatchEvent} from '../resources/MatchEvent';
import {DomainEvent} from './DomainEvent';

export class MatchEventUpdated extends DomainEvent<MatchEvent> {}
